import { isValidPrice } from '@domain-group/javascript-utils'

const state = {
  billable_id: undefined,
  billable_type: '',
  debtor_id: undefined,
  debtor_type: '',
  fee_type: 'fixed',
  global: false,
  id: null,
  value: undefined,
}

export const requiredFields = [
  { key: 'billable_id' },
  { key: 'billable_type' },
  { key: 'debtor_type' },
  { key: 'fee_type' },
  { key: 'value', validation: isValidPrice, invalidMessage: 'Invalid Value' },
]

export default state
